import type { Announcement } from '~/types/strapi';

export const useAnnouncementStore = defineStore('announcement', () => {
  const { $strapi } = useNuxtApp();

  const { data } = useAsyncData('announcement', () => $strapi.single<Announcement>('announcement', {
    populate: [
      'cta',
    ],
  }));

  const announcement = computed(() => data.value?.data.attributes);

  const dismissed = ref(false);

  const visible = computed({
    get: () => !!announcement.value && !dismissed.value,
    set: v => dismissed.value = !v,
  });

  const toggle = () => dismissed.value = !dismissed.value;

  return {
    announcement,
    visible,
    toggle,
  };
});
